import { Spinner, Stack } from "@altimateai/lego";
import { ChatbotProps, ChatSession, sessionStatusSchema } from "../../types";
import { useEffect } from "react";

const RefetchSession = ({
  error,
  currentSession,
  refetchSession,
}: {
  error: string | null;
  currentSession: ChatSession | null;
  refetchSession?: ChatbotProps["refetchSession"];
}) => {
  useEffect(() => {
    if (
      (!error && currentSession?.status !== sessionStatusSchema.enum.pending) ||
      !refetchSession
    ) {
      return;
    }
    let intervalId: NodeJS.Timeout;
    const startRefetching = () => {
      intervalId = setInterval(() => {
        refetchSession();
      }, 30000); // refetch every 30 seconds
    };

    if (currentSession?.status === sessionStatusSchema.enum.pending) {
      startRefetching();
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [error, refetchSession, currentSession?.status]);

  if (currentSession?.status === sessionStatusSchema.enum.pending) {
    return (
      <Stack align="center" role="alert">
        <Spinner />
        Please wait until we process your request...
      </Stack>
    );
  }

  if (error) {
    return (
      <div
        className="al-text-red-500 al-p-4 al-rounded al-bg-red-50 al-mt-4"
        role="alert"
      >
        {error}
      </div>
    );
  }

  return null;
};

export default RefetchSession;
